class Clinic {
    constructor() {

        this.clinicMapEl = document.getElementById('doctor-map');
        if (!this.clinicMapEl) return;

        this.latitude = this.clinicMapEl.getAttribute('data-latitude');
        this.longitude = this.clinicMapEl.getAttribute('data-longitude');
        this.userLocation = {};
        this.currentLocation = '';
        this.fadPrefix = this.getTanslation('fadPrefix');
        this.fadIframePrefix = 'fad-iframe';
        // this.campaignPrefix = 'verpasse-nicht-den-fruehling';

        this.clinic = window.clinic;

        if (!this.clinic) return;

        this.map = null;

        this.init();
    }

    async init() {
        this.setBackToResultsUrl();
        await this.setUserLocation();
        await this.processMap();
        await this.setDirectionLink();
        await this.bindEvents();
    }

    async setUserLocation() {
        // Take value from URL or cookie or current location

        let userLocationLat = null;
        let userLocationLng = null;
        let userLocationCity = null;
        let userLocationCountry = null;

        try {
            userLocationLat = this.getCookie('userLocationLat');
            userLocationLng = this.getCookie('userLocationLng');
            userLocationCity = decodeURI(this.getCookie('userLocationCity'));
            userLocationCountry = decodeURI(this.getCookie('userLocationCountry'));
        } catch (e) {
            console.error(e);
        }

        if (userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {

            this.userLocation = {
                lat: parseFloat(userLocationLat),
                lng: parseFloat(userLocationLng),
            };

            this.currentLocation = `${userLocationCity}, ${userLocationCountry}`;

        }
        else {

            try {
                let response = await fetch(`https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2`);
                response = await response.json();


                if (response.country_name !== window.countryName) {

                    response.latitude = window.defaultUserLocation.lat;
                    response.longitude = window.defaultUserLocation.lng;
                    response.city = window.defaultCity;
                    response.country_name = window.countryName;
                }

                this.userLocation = {
                    lat: response.latitude,
                    lng: response.longitude,
                };

                this.currentLocation = `${response.city}, ${response.country_name}`;

                this.setCookie('userLocationLat', parseFloat(response.latitude).toFixed(8), 30);
                this.setCookie('userLocationLng', parseFloat(response.longitude).toFixed(8), 30);
                this.setCookie('userLocationCity', response.city, 30);
                this.setCookie('userLocationCountry', response.country_name, 30);

            } catch (e) {

                console.error('IP stack API failed', e);
            }
        }
    }

    setDirectionLink() {
        let directionLinkEl = document.getElementById('doctor-direction');
        if (!directionLinkEl) return;

        let directionLink = `https://www.google.com/maps/dir/${this.userLocation.lat},${this.userLocation.lng}/${this.clinic.latitude},${this.clinic.longitude}/data=!3m1!4b1!4m2!4m1!3e0`;
        directionLinkEl.setAttribute('href', directionLink);
    }

    processMap() {
        this.map = new mapboxgl.Map({
            attributionControl: false,
            cooperativeGestures: true,
            dragRotate: false,
            accessToken: window.mapBoxAPIKey,
            container: 'doctor-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center:{
                lng: parseFloat(this.clinic.longitude),
                lat: parseFloat(this.clinic.latitude)
            },
            zoom: window.defaultZoom,
            maxBounds: [[window.countryBounds.west, window.countryBounds.south], [window.countryBounds.east, window.countryBounds.north]]
        });

        this.marker = new mapboxgl.Marker();
        this.marker.setLngLat({
            lat: parseFloat(this.clinic.latitude),
            lng: parseFloat(this.clinic.longitude)
        });
        this.marker.addTo(this.map);

        let loader = document.getElementById('map-loader');
        if (loader) loader.classList.add('d-none');
    }

    bindEvents() {
        document.getElementById('doctor-direction').addEventListener('click', () => {
            this.manageDataLayers('fad-direction-click', null, this.clinic);
        });

        let onlineAppointmentEl = document.getElementById('doctor-online-appointment-url');
        if (onlineAppointmentEl) {
            onlineAppointmentEl.addEventListener('click', () => {
                this.manageDataLayers('fad-online-appointment-click', null, this.clinic);
            });
        }

        let emailEl = document.getElementById('doctor-email');
        if (emailEl) {
            emailEl.addEventListener('click', () => {
                this.manageDataLayers('fad-email-click', null, this.clinic);
            });
        }

        let websiteEl = document.getElementById('doctor-website');
        if (websiteEl) {
            websiteEl.addEventListener('click', () => {
                this.manageDataLayers('fad-website-click', null, this.clinic);
            });
        }

        let phoneEl = document.getElementById('doctor-phone');
        if (phoneEl) {
            phoneEl.addEventListener('click', () => {
                this.manageDataLayers('fad-phone-click', null, this.clinic);
            });
        }

        setTimeout(() => {
            this.manageDataLayers('fad-timer', event);
        }, 15000);
    }

    manageDataLayers(handle, event = null, data = null) {

        console.log(handle, data);

        try {
            switch (handle) {
                case 'fad-phone-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_PhoneClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                        }
                    });
                    break;
                case 'fad-email-click':
                    console.log(data, 'fad-email-click');
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_MailClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            doctorMail: data.email,
                        }
                    });
                    break;
                case 'fad-website-click':
                    console.log(data, 'fad-website-click');
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_WebsiteClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue,
                        }
                    });
                    break;
                case 'fad-direction-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_DirectionsClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city
                        }
                    });
                    break;
                case 'fad-online-appointment-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_BookClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.currentLocation
                        }
                    });
                    break;
                case 'fad-timer':
                    window.dataLayer.push({
                        event: "FAD_Timer15s"
                    });
                    break;
            }

        } catch (e) {
            console.error(e);
            Rollbar.error("Datalayer failed");
        }
    }

    setBackToResultsUrl() {
        let previousURL = document.referrer;
        if (previousURL && (previousURL.includes(this.fadPrefix) || previousURL.includes(this.fadIframePrefix))) {
            previousURL = new URL(previousURL);
            let queryParams = previousURL.searchParams;
            if(this.clinic.doctor_name) queryParams.set('name', this.clinic.doctor_name);
            let element = document.querySelector('.fad-clinic-page #back-to-result');
            if (element) element.setAttribute('href', previousURL.href);
        }
    }

    setCookie(name, value, minutes) {
        let date = new Date();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
        document.cookie = name + "=" + c_value;

        return document.cookie;
    }

    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null; // Cookie not found
    }

    getTanslation(text) {
        try {
            switch (text) {
                case 'fadPrefix':
                    return (this.curLang == 'de' ? 'allergologensuche' : this.curLang == 'fr' ? 'trouver-un-allergologue' : this.curLang == 'it' ? 'trova-un-allergologo' : '');
                    break;
                case 'clinicPagePrefix':
                    return (this.curLang == 'de' ? 'facharztpraxen' : this.curLang == 'fr' ? 'allergologue' : this.curLang == 'it' ? 'allergologo' : '');
                    break;          
            }

        } catch (e) {
            console.error(e);
        }
    }
}

new Clinic();